import color from '@/uptk/core/packages/style/color';

const focusRing = {
  outline: `2px dotted ${color.blue400} !important`
};

export default focusRing;
